import cn from 'classnames'
import React from 'react'
import { FileTypeEnum } from 'utils'

import type { KeyIconsType } from 'components/uiKit/Icon'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { getFinderRecordName } from 'components/uiKit/Table/utils'
import { Typography } from 'components/uiKit/Typography'
import type { FileMetaSchemaFragment } from 'gql/__generated__/graphql'
import type { FinderFileItem, FinderItem } from 'store/models'
import { testProps } from 'utils/test/qaData'
import { getTypeFile } from 'utils/useFinder'

import * as s from './FileComponent.module.scss'

interface IFileComponentProps {
  file: FinderFileItem
  onClick?: (item: FinderItem) => void
  disabled?: boolean
  gap?: number
}

const ICON_MAP: { [key in FileTypeEnum]: KeyIconsType } = {
  [FileTypeEnum.IMAGE]: 'otherImage',
  [FileTypeEnum.AUDIO]: 'iconsOtherAudio',
  [FileTypeEnum.VIDEO]: 'iconsOtherVideo',
  [FileTypeEnum.APPLICATION]: 'otherFile',
  [FileTypeEnum.TEXT]: 'otherFile',
  [FileTypeEnum.FONT]: 'otherFile',
  [FileTypeEnum.TRANSLATE]: 'otherFile',
  [FileTypeEnum.CAPTIONS]: 'otherFile',
}

const FileComponent: React.FC<IFileComponentProps> = ({
  file,
  onClick,
  disabled = false,
  gap = 16,
}) => {
  const fileMeta = file as FileMetaSchemaFragment
  const type = getTypeFile(fileMeta.type) || FileTypeEnum.APPLICATION
  const name = getFinderRecordName(file)
  const iconName = ICON_MAP[type]

  return (
    <div
      className={cn(s.root, { [s.disabled]: disabled })}
      onClick={() => !disabled && onClick?.(file)}
      {...testProps({ el: 'file', name })}
    >
      <div className={s.iconWrapper}>
        {file.img && type === FileTypeEnum.IMAGE ? (
          <div
            className={s.previewImg}
            style={{ backgroundImage: `url(${file.img})`, marginRight: gap }}
          />
        ) : (
          <Icon className={s.icon} name={iconName} size={KitSize.S} style={{ marginRight: gap }} />
        )}
      </div>
      <div className={s.content}>
        <Typography rows={1}>{file.nodeName || name}</Typography>
      </div>
    </div>
  )
}

export default FileComponent
